import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ITOPack {
  amount: number;
  price: number;
}

export interface ITOStats {
  kdaId: string;
  totalSupply: number;
  maxAmount: number;
  currentAmount: number;
  availableAmount: number;
  priceInKLV: number;
  startTime: number;
  endTime: number;
  status: string;
  receiverAddress: string;
  packs: ITOPack[];
  timestamp: number;
}

export interface ITOGlobalStats {
  totalBuyers: number;
  totalKLYXSold: number;
  totalKLVRaised: number;
  totalTransactions: number;
}

interface ITOState {
  stats: ITOStats | null;
  globalStats: ITOGlobalStats | null;
  isLoading: boolean;
  error: string | null;
}

const initialState: ITOState = {
  stats: null,
  globalStats: null,
  isLoading: false,
  error: null,
};

const itoSlice = createSlice({
  name: 'ito',
  initialState,
  reducers: {
    setStats: (state, action: PayloadAction<ITOStats>) => {
      state.stats = action.payload;
      state.error = null;
    },

    setGlobalStats: (state, action: PayloadAction<ITOGlobalStats>) => {
      state.globalStats = action.payload;
      state.error = null;
    },

    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },

    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },

    clearError: (state) => {
      state.error = null;
    },

    resetITO: (state) => {
      state.stats = null;
      state.globalStats = null;
      state.isLoading = false;
      state.error = null;
    },
  },
});

export const {
  setStats,
  setGlobalStats,
  setLoading,
  setError,
  clearError,
  resetITO,
} = itoSlice.actions;

export default itoSlice.reducer;
